<div [class.done]="updaterService.checkedForUpdates && (!updaterService.updateAvailable)" id="container">
  <img id="logo" src="assets/App%20Icon%203C.png">
  <div class="p-grid fluid-ui-replacer" id="box">
    <div *ngIf="!updaterService.checkedForUpdates" class="col-12 p-nogutter" style="text-align: center">Checking
      for updates
    </div>
    <div *ngIf="updaterService.checkedForUpdates && !updaterService.updateAvailable" class="col-12 p-nogutter"
         style="text-align: center">You are running the latest version
    </div>
    <div *ngIf="updaterService.checkedForUpdates && updaterService.updateAvailable" class="col-12 p-nogutter"
         style="text-align: center">An update is available
    </div>
    <div *ngIf="updaterService.checkedForUpdates && updaterService.updateAvailable" class="col-12 p-nogutter"
         style="text-align: center"></div>
    <div *ngIf="updaterService.checkedForUpdates && updaterService.updateAvailable"
         class="col-12 p-nogutter progress-bar">
      <div [style]="progressStyle" class="progress-bar-value"></div>
    </div>
  </div>
</div>
